import { render, staticRenderFns } from "./BookEntryRegistryDetailsCard.vue?vue&type=template&id=379dd1cc&"
import script from "./BookEntryRegistryDetailsCard.vue?vue&type=script&lang=js&"
export * from "./BookEntryRegistryDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports